import React from 'react';
import { trackAgencyRecommendations } from '../../tracking';
import { AgencyRecommendationsWithFragment } from '..';
import { AgencyRecommendationsWithPagination } from './agency-recommendations-with-gql-pagination';

type AgencyRecommendationsProps = {
  agencyId: number;
  starRatingsEnabled?: boolean;
};

function AgencyRecommendations({
  agencyId,
  starRatingsEnabled = false,
}: AgencyRecommendationsProps): JSX.Element {
  if (starRatingsEnabled) {
    return (
      <AgencyRecommendationsWithPagination
        agencyId={agencyId}
        onPageRendered={trackAgencyRecommendations.trackAgencyPageRendered}
        onVendorRecoViewAll={trackAgencyRecommendations.trackAgencyViewAll}
        onVendorRecoRendered={trackAgencyRecommendations.trackAgencyRendered}
        onVendorRecoImpression={
          trackAgencyRecommendations.trackAgencyImpression
        }
        onVendorRecoModalViewMore={
          trackAgencyRecommendations.trackAgencyModalViewMore
        }
        starRatingsEnabled={starRatingsEnabled}
        onVendorRecoShowMore={trackAgencyRecommendations.trackAgencyShowMore}
      />
    );
  }
  return (
    <AgencyRecommendationsWithFragment
      agencyId={agencyId}
      onPageRendered={trackAgencyRecommendations.trackAgencyPageRendered}
      onVendorRecoViewAll={trackAgencyRecommendations.trackAgencyViewAll}
      onVendorRecoRendered={trackAgencyRecommendations.trackAgencyRendered}
      onVendorRecoImpression={trackAgencyRecommendations.trackAgencyImpression}
      onVendorRecoModalViewMore={
        trackAgencyRecommendations.trackAgencyModalViewMore
      }
      onVendorRecoModalPrev={
        trackAgencyRecommendations.trackAgencyModalPrevious
      }
      onVendorRecoModalNext={trackAgencyRecommendations.trackAgencyModalNext}
      starRatingsEnabled={starRatingsEnabled}
    />
  );
}

export default AgencyRecommendations;
